import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
function Refund() {
  return (
    <>
      <Navbar />
      <div className="news-banner news-banner-refund">
        <p>Refund Policy</p>
        <br />
        <h1>Refund & Cancellation Policy – Cine Celebrate</h1>
        <p>Effective Date: 24/07/2025</p>
        <p>Website:www.cinecelebrate.com</p>
      </div>
      <div className="refund-revamp">
        <div className="refund-revamp__intro">
          <p className="refund-revamp__eyebrow">Refund Guide</p>
          <h2>Clear cancellation and refund rules, before your celebration date arrives.</h2>
          <p>
          At Cine Celebrate, we strive to provide exceptional service and
          memorable experiences through our private theater celebrations.
          However, we understand that plans may change. This Refund &
          Cancellation Policy outlines the terms and conditions for refunds,
          cancellations, and rescheduling.
          </p>
        </div>

        <ol className="refund-revamp__list">
          <li>
            <strong>Full Refund Eligibility</strong>
            <ul>
              <li>
                You are eligible for a full refund (excluding payment gateway
                convenience charges, if applicable) only if your cancellation
                request is made at least 72 hours (3 days) before the scheduled
                date and time of your booking.
              </li>
            </ul>
          </li>
          <li>
            <strong>Cancellations Within 72 Hours</strong>
            <ul>
              <li>
                If a cancellation is requested within 72 hours of the scheduled
                event, no refund will be provided.
              </li>
            </ul>
          </li>
          <li>
            <strong>How to Request a Refund</strong>
            <ul>
              <li>
                You may cancel your booking and request a refund through any of
                the following methods:
              </li>
              <ul>
                <li>
                  <strong>Booking Dashboard:</strong>
                </li>
                <ul>
                  <li>
                    1. Log in to your Cine Celebrate account at
                    www.cinecelebrate.com
                  </li>
                  <li>2. Navigate to the Booking Dashboard</li>
                  <li>3. Select the booking you wish to cancel</li>
                  <li>
                    4. Click "Request Refund" and follow the on-screen
                    instructions
                  </li>
                </ul>
                <li>
                  <strong>Email:</strong> Send your cancellation request to
                  services@cinecelebrate.com with your booking reference number
                  and registered details.
                </li>
                <li>
                  <strong>WhatsApp:</strong> Message your cancellation details
                  to +91-9643055509 including your booking reference number and
                  registered name.
                </li>
              </ul>
              <li>
                Our support team will verify your request and process it
                accordingly.
              </li>
            </ul>
          </li>
          <li>
            <strong>Refund Processing & Timeline</strong>
            <ul>
              <li>
                • Refunds are typically processed within 24 hours of approval.
              </li>
              <li>
                • It may take 3–5 business days for the refunded amount to
                reflect in your bank or payment provider account, depending on
                your provider’s processing time.
              </li>
            </ul>
          </li>
          <li>
            <strong>Rescheduling Policy</strong>
            <ul>
              <li>
                Prefer to reschedule instead of cancel?
                <br />
                Customers may request a date or time reschedule, subject to
                availability and confirmation from our team. Rescheduling must
                be requested at least 72 hours in advance.
              </li>
            </ul>
          </li>
          <li>
            <strong>No-Show Policy</strong>
            <ul>
              <li>
                If the customer fails to show up at the venue without prior
                cancellation or rescheduling, no refund or reschedule will be
                offered.
              </li>
            </ul>
          </li>
          <li>
            <strong>Exceptional Cases</strong>
            <ul>
              <li>
                In rare circumstances where technical issues, service
                disruptions, or unforeseen events occur from our side, Cine
                Celebrate may issue a full refund or reschedule at its sole
                discretion.
              </li>
            </ul>
          </li>
          <li>
            <strong>Contact for Refund Queries</strong>
            <b>
              For any questions, concerns, or assistance related to
              cancellations or refunds:
            </b>
            <ul>
              <li> Email:services@cinecelebrate.com</li>
              <li>WhatsApp:+91-9643055509</li>
            </ul>
          </li>
        </ol>

        <div className="refund-revamp__footer">
          <p className="refund-revamp__eyebrow">Final Note</p>
          <p>
          By booking with Cine Celebrate, you acknowledge and agree to the terms
          of this Refund & Cancellation Policy. We thank you for your trust and
          understanding.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Refund;
